/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

type StatCardVariant = "light" | "dark";
type StatCardAccent = "blue" | "green" | "red" | "yellow" | "purple" | "orange";

interface StatCardProps {
	label: string;
	value: string | number;
	sublabel: string;
	variant?: StatCardVariant;
	accent?: StatCardAccent; // only applies to "light" variant
}

const accentColorMap: Record<StatCardAccent, string> = {
	blue: "text-blue-500",
	green: "text-green-500",
	red: "text-red-500",
	yellow: "text-yellow-500",
	purple: "text-purple-500",
	orange: "text-orange-500",
};

function ReconStatCard({
	label,
	value,
	sublabel,
	variant = "light",
	accent = "blue",
}: StatCardProps) {
	if (variant === "dark") {
		return (
			<div className="bg-[#2D3E50] px-6 py-1 rounded-2xl text-white shadow-lg">
				<p className="text-[10px] font-black text-white/40 uppercase tracking-widest leading-none mt-2">
					{label}
				</p>
				<p className="text-xl font-black leading-none">{value}</p>
				<p className="text-[10px] text-white/40 font-bold uppercase leading-none mb-2">
					{sublabel}
				</p>
			</div>
		);
	}

	return (
		<div className="bg-white px-6 py-1 rounded-2xl border border-slate-200 shadow-sm">
			<p className="text-[10px] font-black text-slate-400 uppercase tracking-widest leading-none mt-2">
				{label}
			</p>
			<p
				className={`text-xl font-black leading-none ${accentColorMap[accent]}`}
			>
				{value}
			</p>
			<p className="text-[10px] text-slate-400 font-bold uppercase leading-none mb-2">
				{sublabel}
			</p>
		</div>
	);
}

export default ReconStatCard;
